import type { QueryCriteria, ResponseType } from '@/api/types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { drillsMutations } from './mutations';
import { drillsQueries, drillTypesQueries } from './queries';
import type { DrillEx } from './schema';

export const useDrills = (criteria?: QueryCriteria, resType: ResponseType = 'flat') => {
  return useQuery(drillsQueries.list(criteria, resType));
};

export const useDrill = (id: string) => {
  return useQuery(drillsQueries.detail(id));
};

export const useNextDrills = (criteria?: QueryCriteria) => {
  return useQuery(drillsQueries.nextDrills(criteria));
};

export const useSaveDrill = (drill: DrillEx) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...drillsMutations.saveDrill(drill),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: drillsQueries.all() });

      if (drill.Id) {
        void queryClient.invalidateQueries({ queryKey: drillsQueries.detail(drill.Id).queryKey });
      }
    }
  });
};

export const useDeleteDrill = (id: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...drillsMutations.deleteDrill(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: drillsQueries.all() });

      queryClient.removeQueries({ queryKey: drillsQueries.detail(id).queryKey });
    }
  });
};

export const useDrillTypes = (criteria?: QueryCriteria) => {
  return useQuery(drillTypesQueries.list(criteria));
};
